export const isDocumentUploadFeatureEnabled = () =>
  process.env.REACT_APP_ENABLE_DOCUMENT_UPLOAD !== 'false';

export const isDocumentsDownloadOnly = () =>
  process.env.REACT_APP_DOCUMENTS_DOWNLOAD_ONLY === 'true';

/** Standalone "Digitalizar documentos" page (/documentos) and menu entry */
export const canAccessDocumentDigitizationPage = () =>
  isDocumentUploadFeatureEnabled() && !isDocumentsDownloadOnly();
